import {
  apiRequest,
  masterWorkUnit,
  Employee,
  lemburExport,
  tidakhadirperunitExport,
  akumulasiperunitExport,
  izinperunitExport,
  izinperunitExport2,
  kehadiranPerorangExport,
  kehadiranPerunitExport,
  izinSTperunitExport,
  tidakhadirperunitExportAlpha,
  absensiPerunitExport,
  absensiPerunitRealTimeExport,
  absensiPerorangExport,
  kehadiranPerunitExportLibur,
} from "../../../../../services/adapters/Laporan/presensiService";

class IndexRepository {
  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      lemburExport,
      {
        params: query,
      },
      true
    );
  };
  fetchExport_tdkhadirperunit = async (query) => {
    return await apiRequest(
      "get",
      tidakhadirperunitExport,
      {
        params: query,
      },
      true
    );
  };
  fetchExport_tdkhadirperunitAlpha = async (query) => {
    return await apiRequest(
      "get",
      tidakhadirperunitExportAlpha,
      {
        params: query,
      },
      true
    );
  };
  fetchAkumulasiperunit = async (query) => {
    return await apiRequest(
      "get",
      akumulasiperunitExport,
      {
        params: query,
      },
      true
    );
  };
  fetchIzinExport = async (query) => {
    return await apiRequest(
      "get",
      izinperunitExport,
      {
        params: query,
      },
      true
    );
  };
  fetchIzinExport2 = async (query) => {
    //include hari libur dan tanggal merah
    return await apiRequest(
      "get",
      izinperunitExport2,
      {
        params: query,
      },
      true
    );
  };
  fetchIzinSTExport = async (query) => {
    //include hari libur dan tanggal merah
    return await apiRequest(
      "get",
      izinSTperunitExport,
      {
        params: query,
      },
      true
    );
  };
  fetchKehadiranPerorangExport = async (query) => {
    return await apiRequest(
      "get",
      kehadiranPerorangExport,
      {
        params: query,
      },
      true
    );
  };
  fetchAbsensiPerorangExport = async (query) => {
    return await apiRequest(
      "get",
      absensiPerorangExport,
      {
        params: query,
      },
      true
    );
  };
  fetchKehadiranPerUnitExport = async (query) => {
    return await apiRequest(
      "get",
      kehadiranPerunitExport,
      {
        params: query,
      },
      true
    );
  };
  fetchAbsensiPerUnitExport = async (query) => {
    return await apiRequest(
      "get",
      absensiPerunitExport,
      {
        params: query,
      },
      true
    );
  };
  fetchAbsensiPerunitRealTimeExport = async (query) => {
    return await apiRequest(
      "get",
      absensiPerunitRealTimeExport,
      {
        params: query,
      },
      true
    );
  };
  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      Employee,
      {
        params: query,
      },
      true
    );
  };
  fetchKehadiranPerUnitLiburExport = async (query) => {
    return await apiRequest(
      "get",
      kehadiranPerunitExportLibur,
      {
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
